import React from 'react'
import EditarVenta from './EditarVenta'
import EliminarVenta from './EliminarVenta'

function OperacionesVentaAExportador (props) {
  const { data } = props
  return (
    <div style={{ display: 'flex' }}>
      <EditarVenta data={data} />
      <EliminarVenta data={data} />
    </div>
  )
}

export default OperacionesVentaAExportador
